// React
import React from 'react';
import classNames from 'classnames';
// External libs
import Ripples from 'react-ripples';
// Styles
import useStyles from './CustomRipples.styles';

const CustomRipples = ({ children, classes, onClick, ripples }) => {
  const componentClasses = useStyles({ ripples });

  return ripples ? (
    <Ripples
      className={classNames(componentClasses.root, classes.root)}
      onClick={onClick}
    >
      {children}
    </Ripples>
  ) : (
    <div
      className={classNames(componentClasses.root, classes.root)}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

CustomRipples.defaultProps = {
  children: null,
  classes: {},
  onClick: () => {},
  ripples: true,
};

export default CustomRipples;
